/* JC External Links (Sep 20). Shopify menus cannot mark a link to open
   in a new tab, so any menu link whose host is not this store gets
   target="_blank" here. Covers the header menu, mega menu, mobile
   drawer and footer. Re-runs when Horizon re-renders menus. */
(function () {
  function mark(root) {
    var links = (root || document).querySelectorAll('a[href^="http"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.target === '_blank') continue;
      if (a.host && a.host !== location.host) {
        a.target = '_blank';
        a.rel = (a.rel ? a.rel + ' ' : '') + 'noopener';
      }
    }
  }
  function run() { mark(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { run(); break; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
